//  1. Variables
//  2. Sizing Functions
//  3. Navigation Functions
//  4. Initiations

//  1. Variables
// -------------

const forceMobileNavInput = document.getElementById('force-mobile-nav')
const forceFooterMobileInput = document.getElementById('force-mobile-footer')
const openMobileNavInput = document.getElementById('open-mobile-nav')
const header = document.getElementById('header')
const headerLogo = document.getElementById('header-logo')
const htmlTag = document.getElementsByTagName('html')[0]

const footer = {
    elem: document.getElementById('footer'),
    logo: document.getElementsByClassName('footer-logo')[0],
    nav: document.getElementsByClassName('footer__right-side')[0],
}
const mainNav = {
    elem              : document.getElementById('nav-main'),
    toggleBtn         : document.getElementById('toggle-menu-button'),
    toggleCheckbox    : document.getElementById('open-mobile-nav'),
    backdrop          : document.getElementById('mobile-nav-backdrop'),
    backdropDiameter  : 50,
    ul                : document.getElementById('nav-main').getElementsByTagName('ul')[0],
    items             : document.getElementById('nav-main').getElementsByTagName('ul')[0].getElementsByTagName('li')
};
// console.log({'mainNav' : mainNav});

mainNav.toggleCheckbox.checked = false  // makes sure this is unchecked when the back button is hit

forceMobileNavInput.checked =  false
forceFooterMobileInput.checked = false;

// get vendor transition property
let docElemStyle = document.documentElement.style;
let transitionProp = typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition'

//  2. Functions
// -------------

const getOuterWidth = (elem) => {
    return elem.getBoundingClientRect().width
}

var poll = (function(){
    var timer = 0;
    return function(callback, ms){
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

const getAvailableSpace = (element) => {
    let elemWidth = element.getBoundingClientRect().width
    let padding = {
        left: parseInt(window.getComputedStyle(element, null).getPropertyValue('padding-left'), 10),
        right: parseInt(window.getComputedStyle(element, null).getPropertyValue('padding-right', 10))
    }
    return elemWidth - padding.left - padding.right
}

const checkIfStuffFits = (containerElem, itemsToFit, buffer = 50) => {
    let availableSpace = getAvailableSpace(containerElem)
    let childWidths = []
    for (var i = itemsToFit.length - 1; i >= 0; i--) {
        let outerWidth = getOuterWidth(itemsToFit[i])
        // console.log('outerWidth: ', outerWidth );
        childWidths.push(outerWidth)
    }

    let occupiedSpace = childWidths.reduce((a, b) => a + b, buffer)
    // console.log({
    //     availableSpace: availableSpace,
    //     childWidths: childWidths,
    //     occupiedSpace: occupiedSpace
    // })
    return availableSpace > occupiedSpace
}


const handleWindowResize = () => {
        forceMobileNavInput.checked = false
        forceFooterMobileInput.checked = false
        forceMobileNavInput.checked = !checkIfStuffFits(header, [headerLogo, mainNav.elem])
        forceFooterMobileInput.checked = !checkIfStuffFits(footer.elem, [footer.nav, footer.logo])
        mainNav.elem.setAttribute("style", "opacity: 1");
        changeMenuStatus(true)
        setTimeout(function() {
        }, 100);
}

//  3. Navigation Functions
//  -----------------------
const changeMenuStatus = (forceClose = false) => {
    let numMenuItems = mainNav.items.length;
    let wasChecked = mainNav.toggleCheckbox.checked
    let isChecked = forceClose ? false : !wasChecked

    mainNav.toggleCheckbox.checked = isChecked


    if(isChecked) {
        htmlTag.classList.add('nav-no-scroll')

        animateBackdrop("open");

        // Stagger li item animation
        for ( let i=0; i < numMenuItems; i++ ) {
            let item = mainNav.items[i];
            // stagger transition with transitionDelay
            item.style[ transitionProp + 'Delay' ] = ( i * 50 ) + 100 + 'ms';
        }
        // hamburgerClose.play();
        setTimeout(function(){
            // removeLiTransforms();
        }, 1000);
    } else {
        animateBackdrop("close");
        let menuRetractTime = numMenuItems * 40;
        for ( let i=0; i < numMenuItems; i++ ) {
            let item = mainNav.items[i];
            // stagger transition with transitionDelay
            item.style[ transitionProp + 'Delay' ] = menuRetractTime - ( i * 40 ) + 'ms';
        }
        setTimeout(function(){
            htmlTag.classList.remove('nav-no-scroll')
        }, 600);
    }
}

const animateBackdrop = (openClose) => {
    let vh = window.innerHeight;
    let vw = window.innerWidth;
    let radiusToFill = Math.sqrt((vw * vw) + (vh * vh)); 
    let circleRadius = (mainNav.backdropDiameter / 2);
    let scaleTo = 1;
    if(openClose === "open") {
        scaleTo = Math.ceil(radiusToFill / circleRadius);
    }
    mainNav.backdrop.style.transform = 'scale(' + scaleTo + ')'
}


//  4. Initiations
// ---------------

let footerTestSize = checkIfStuffFits(footer.elem, [footer.nav, footer.logo])
mainNav.elem.setAttribute("style", "opacity: 0");



handleWindowResize()

window.addEventListener('resize', () => {
    handleWindowResize()
});


mainNav.toggleBtn.onclick = (e) => { changeMenuStatus() }